module.exports = __webpack_public_path__ + "img/roboto-mono-dark.05ea9e1a.png";